import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import DescriptionOutlined from '@mui/icons-material/DescriptionOutlined';
import { HelpCenterArticleListItem } from '../models/helpCenterArticleListItem';

type HelpPanelSuggestionsProps = {
  /** Modulen som sidan hör till, eller null för sidor utan modul. */
  moduleKey: string | null;
  articles: HelpCenterArticleListItem[];
  loading: boolean;
  failed: boolean;
  onOpen: (slug: string) => void;
};

/** Hjälppanelens förslag: artiklarna som är taggade med sidans modul. */
export const HelpPanelSuggestions = (props: HelpPanelSuggestionsProps) => {
  const { moduleKey, articles, loading, failed, onOpen } = props;
  const { t } = useTranslation(['help', 'helpArticles']);

  return (
    <>
      {moduleKey && (
        <Typography variant='subtitle2' color='text.secondary' sx={{ mb: 1 }}>
          {t('help:panelArticlesAbout', { module: t(`helpArticles:moduleNames.${moduleKey}`) })}
        </Typography>
      )}
      {loading && (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}>
          <CircularProgress size={28} />
        </Box>
      )}
      {!loading && failed && <Typography color='text.secondary'>{t('help:loadFailed')}</Typography>}
      {!loading && !failed && articles.length === 0 && <Typography color='text.secondary'>{t('help:panelNoSuggestions')}</Typography>}
      {!loading && articles.length > 0 && (
        <List disablePadding>
          {articles.map((article) => (
            <ListItemButton key={article.slug} onClick={() => onOpen(article.slug)} sx={{ borderRadius: 1 }}>
              <ListItemIcon sx={{ minWidth: 36 }}>
                <DescriptionOutlined fontSize='small' color='primary' />
              </ListItemIcon>
              <ListItemText primary={article.title} />
            </ListItemButton>
          ))}
        </List>
      )}
    </>
  );
};
